import React, { useEffect, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
// config file

/**
 * !PLEASE DO NOT REMOVE THE BELOW FIELDS
 * !THESE FIELDS WILL BE REPLACED IN THE BACKEND AS PER REQUIREMENT
 * @Categories
 * @Categories
 * @categories
 * @[{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"categoryType","type":"dropDown","placeholder":"Category Type","label":"Category Type","width":"130px","addFormOrder":7,"editFormOrder":7,"header":"Category Type","derivedValue":"categoryType=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"categoryType","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"options":[{"label":"Medicine","value":"Medicine","color":"primary"},{"label":"Non-Medicine","value":"Non-Medicine","color":"primary"}],"fieldType":"dropDown","dependent":[],"textAlign":"Center","show":true,"field":"categoryType","showOrHideFields":[],"label0":"Medicine","color0":"primary","value0":"Medicine","label1":"Non-Medicine","color1":"primary","value1":"Non-Medicine","fieldName":"categoryType","mobile":true,"displayInSettings":true},{"name":"useType","type":"dropDown","placeholder":"Use Type","label":"Use Type","width":"130px","addFormOrder":8,"editFormOrder":8,"header":"Use Type","derivedValue":"useType=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"useType","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"options":[{"label":"SingleUse","value":"SingleUse","color":"primary"},{"label":"MultiUse","value":"MultiUse","color":"primary"}],"fieldType":"dropDown","dependent":[],"textAlign":"Center","show":true,"field":"useType","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"createdByName","type":"Text","placeholder":"Created By","label":"Created By","width":120,"header":"Created By","id":"createdByName","displayinlist":"true","globalSearchField":"false","controllerId":1001,"fieldType":"Text","textAlign":"Center","show":true,"field":"createdByName","mobile":true,"filter":true,"displayInSettings":true},{"name":"updatedByName","type":"Text","placeholder":"Updated By","label":"Updated By","width":120,"header":"Updated By","id":"updatedByName","displayinlist":"true","fieldType":"Text","textAlign":"Center","show":true,"filter":true,"field":"updatedByName","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true},{"name":"status","type":"text","placeholder":"Status","label":"Status","width":"130px","addFormOrder":10,"editFormOrder":10,"header":"Status","derivedValue":"status=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"status","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":true,"field":"status","showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}}]
 * @[{"name":"categoryType","type":"dropDown","placeholder":"Category Type","label":"Category Type","width":"130px","addFormOrder":7,"editFormOrder":7,"derivedValue":"categoryType=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"categoryType","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"options":[{"label":"Medicine","value":"Medicine","color":"primary"},{"label":"Non-Medicine","value":"Non-Medicine","color":"primary"}],"fieldType":"dropDown","dependent":[],"show":true,"showOrHideFields":[],"label0":"Medicine","color0":"primary","value0":"Medicine","label1":"Non-Medicine","color1":"primary","value1":"Non-Medicine","fieldName":"categoryType","mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"useType","type":"dropDown","placeholder":"Use Type","label":"Use Type","width":"130px","addFormOrder":8,"editFormOrder":8,"derivedValue":"useType=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"useType","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"options":[{"label":"SingleUse","value":"SingleUse","color":"primary"},{"label":"MultiUse","value":"MultiUse","color":"primary"}],"fieldType":"dropDown","dependent":[],"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"status","type":"text","placeholder":"Status","label":"Status","width":"130px","addFormOrder":10,"editFormOrder":10,"derivedValue":"status=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"status","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"},"isAddFormHidden":true,"isEditFormHidden":true}]
 * @
 * @
 * @
 *
 *
 *
 */

const Categories = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);
  const query = new URLSearchParams(location.search);
  const companyId = query.get('comapnyId');
  const params = useParams();
  useEffect(() => {
    let screenPermissions = RolePermissions.screenPermissions("Categories");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
  }, []);

  const getDerivedStateFromProps = (props, state) => {
    let storeData = store.getState();
    let languageData =
      storeData &&
        storeData.settingsData &&
        storeData.settingsData.settings &&
        storeData.settingsData.settings.languageTranslation
        ? storeData.settingsData.settings.languageTranslation
        : "";
    return { languageData: languageData };
  };
  // componentDidMount = () => {
  //   //Screen permisions value can be edit,view, no view
  //   let screenPermissions = RolePermissions.screenPermissions('Test');
  //   if (screenPermissions) {
  //     this.setState({
  //       rolePermission: screenPermissions
  //     })
  //   }
  //   // this.getRoleListFromServer()
  // }
  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };

  const getTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [
      /**not using For Now */
      // {
      //   textAlign: "center",
      //   width: 47,
      //   field: "Check Box",
      //   label: "Check Box",
      //   fieldType: "multiple",
      //   header: "",
      //   selectionMode: "multiple",
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      // },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "categoryName",
        type: "Text",
        placeholder: "category Name",
        label: "categoryName",
        width: 120,
        header: "Category Name",
        id: "categoryName",
        displayinlist: "true",
        globalSearchField: "true",
        controllerId: 1001,
        fieldType: "Text",
        capitalizeTableText: true,
        textAlign: "left",
        show: true,
        field: "categoryName",
        mobile: true,
        filter: false,
        sortable: true,
        displayInSettings: true,
      },
      {
        name: "categoryType",
        type: "dropDown",
        placeholder: "Category Type",
        label: "Category Type",
        width: "130px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Category Type",
        derivedValue: "categoryType=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "categoryType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        options: [
          { label: "Medicine", value: "Medicine", color: "primary" },
          { label: "Non-Medicine", value: "Non-Medicine", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        textAlign: "left",
        show: true,
        field: "categoryType",
        showOrHideFields: [],
        label0: "Medicine",
        color0: "primary",
        value0: "Medicine",
        label1: "Non-Medicine",
        color1: "primary",
        value1: "Non-Medicine",
        fieldName: "categoryType",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "useType",
        type: "dropDown",
        placeholder: "Use Type",
        label: "Use Type",
        width: "130px",
        addFormOrder: 8,
        editFormOrder: 8,
        header: "Use Type",
        derivedValue: "useType=undefined",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "useType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        options: [
          { label: "SingleUse", value: "SingleUse", color: "primary" },
          { label: "MultiUse", value: "MultiUse", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        textAlign: "center",
        show: true,
        field: "useType",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      /**not using For Now */
      // {
      //   name: "updatedByName",
      //   type: "Text",
      //   placeholder: "Updated By",
      //   label: "Updated By",
      //   width: 120,
      //   header: "Updated By",
      //   id: "updatedByName",
      //   displayinlist: "true",
      //   fieldType: "Text",
      //   textAlign: "Center",
      //   show: true,
      //   filter: true,
      //   field: "updatedByName",
      //   mobile: true,
      //   displayInSettings: true,
      // },
      // {
      //   name: "createdByName",
      //   type: "Text",
      //   placeholder: "Created By",
      //   label: "Created By",
      //   width: 120,
      //   header: "Created By",
      //   id: "createdByName",
      //   displayinlist: "true",
      //   globalSearchField: "false",
      //   controllerId: 1001,
      //   fieldType: "Text",
      //   textAlign: "Center",
      //   show: true,
      //   field: "createdByName",
      //   mobile: true,
      //   filter: true,
      //   displayInSettings: true,
      // },
      // {
      //   name: "updatedByName",
      //   type: "Text",
      //   placeholder: "Updated By",
      //   label: "Updated By",
      //   width: 120,
      //   header: "Updated By",
      //   id: "updatedByName",
      //   displayinlist: "true",
      //   fieldType: "Text",
      //   textAlign: "Center",
      //   show: true,
      //   filter: true,
      //   field: "updatedByName",
      //   mobile: true,
      //   displayInSettings: true,
      // },
      // {
      //   name: "created",
      //   type: "date",
      //   placeholder: "Created",
      //   label: "Created",
      //   width: 90,
      //   header: "Created",
      //   derivedValue: "created=undefined",
      //   actions: [],
      //   actionsNumber: [],
      //   id: "created",
      //   displayinaddForm: "false",
      //   displayineditForm: "false",
      //   displayinlist: "true",
      //   globalSearchField: "false",
      //   controllerId: null,
      //   fieldType: "Date",
      //   dateFormat: "YYYY-MM-DD HH:mm:ss",
      //   textAlign: "Center",
      //   disabled: true,
      //   show: true,
      //   field: "created",
      //   mobile: true,
      //   displayInSettings: true,
      // },
      // {
      //   name: "updated",
      //   type: "date",
      //   placeholder: "Updated",
      //   label: "Updated",
      //   width: 90,
      //   header: "Updated",
      //   derivedValue: "updated=undefined",
      //   actions: [],
      //   actionsNumber: [],
      //   id: "updated",
      //   displayinaddForm: "false",
      //   displayineditForm: "false",
      //   displayinlist: "true",
      //   globalSearchField: "false",
      //   controllerId: null,
      //   fieldType: "Date",
      //   dateFormat: "YYYY-MM-DD HH:mm:ss",
      //   textAlign: "Center",
      //   disabled: true,
      //   show: true,
      //   field: "updated",
      //   mobile: true,
      //   displayInSettings: true,
      // },
      {
        name: "status",
        type: "text",
        placeholder: "Status",
        label: "Status",
        width: "130px",
        addFormOrder: 10,
        editFormOrder: 10,
        header: "Status",
        derivedValue: "status=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        // fieldType: 'Badge',
        actionsNumber: [],
        id: "status",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "true",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "status",
        fieldType: 'ActiveStatus',
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        // fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
      },
    ];
    return data;
  };

  const getFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "categoryName",
        type: "Text",
        placeholder: "Category Name",
        label: "Category Name",
        width: 120,
        header: "Category Name",
        id: "categoryName",
        addFormOrder: 1,
        editFormOrder: 1,
        displayinlist: "true",
        globalSearchField: "true",
        controllerId: 1001,
        isFieldRequired: "false",
        required: true,
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        isFieldRequired: "true",

        field: "categoryName",
        mobile: true,
        filter: true,
        displayInSettings: true,
      },
      {
        name: "categoryType",
        type: "dropDown",
        placeholder: "Category Type",
        label: "Category Type",
        width: "130px",
        addFormOrder: 7,
        editFormOrder: 7,
        derivedValue: "categoryType=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "categoryType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        options: [
          { label: "Medicine", value: "Medicine", color: "primary" },
          { label: "Non-Medicine", value: "Non-Medicine", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        show: true,
        showOrHideFields: [],
        label0: "Medicine",
        color0: "primary",
        value0: "Medicine",
        label1: "Non-Medicine",
        color1: "primary",
        value1: "Non-Medicine",
        fieldName: "categoryType",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "useType",
        type: "dropDown",
        placeholder: "Use Type",
        label: "Use Type",
        width: "130px",
        addFormOrder: 8,
        editFormOrder: 8,
        derivedValue: "useType=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "useType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        options: [
          { label: "SingleUse", value: "SingleUse", color: "primary" },
          { label: "MultiUse", value: "MultiUse", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        disabled: true,
        show: true,
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: true,
        isEditFormHidden: true,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        disabled: true,
        show: true,
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: true,
        isEditFormHidden: true,
      },
      {
        name: "status",
        type: "text",
        placeholder: "Status",
        label: "Status",
        width: "130px",
        addFormOrder: 10,
        editFormOrder: 10,
        derivedValue: "status=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "status",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "true",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        isAddFormHidden: true,
        isEditFormHidden: true,
      },
    ];
  };

  const submit = async (item) => {
    setIsOpenFormModal(true);
  };
  const getMobileTableFields = () => {
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "categoryType",
        type: "dropDown",
        placeholder: "Category Type",
        label: "Category Type",
        width: "130px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Category Type",
        derivedValue: "categoryType=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "categoryType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        options: [
          { label: "Medicine", value: "Medicine", color: "primary" },
          { label: "Non-Medicine", value: "Non-Medicine", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        textAlign: "Center",
        show: true,
        field: "categoryType",
        showOrHideFields: [],
        label0: "Medicine",
        color0: "primary",
        value0: "Medicine",
        label1: "Non-Medicine",
        color1: "primary",
        value1: "Non-Medicine",
        fieldName: "categoryType",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "useType",
        type: "dropDown",
        placeholder: "Use Type",
        label: "Use Type",
        width: "130px",
        addFormOrder: 8,
        editFormOrder: 8,
        header: "Use Type",
        derivedValue: "useType=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "useType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        options: [
          { label: "SingleUse", value: "SingleUse", color: "primary" },
          { label: "MultiUse", value: "MultiUse", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        textAlign: "Center",
        show: true,
        field: "useType",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "createdByName",
        type: "Text",
        placeholder: "Created By",
        label: "Created By",
        width: 120,
        header: "Created By",
        id: "createdByName",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: 1001,
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        field: "createdByName",
        mobile: true,
        filter: true,
        displayInSettings: true,
      },
      {
        name: "updatedByName",
        type: "Text",
        placeholder: "Updated By",
        label: "Updated By",
        width: 120,
        header: "Updated By",
        id: "updatedByName",
        displayinlist: "true",
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        filter: true,
        field: "updatedByName",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        header: "Created",
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "created",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        header: "Updated",
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "updated",
        mobile: true,
        displayInSettings: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },
      {
        name: "status",
        type: "text",
        placeholder: "Status",
        label: "Status",
        width: "130px",
        addFormOrder: 10,
        editFormOrder: 10,
        header: "Status",
        derivedValue: "status=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "status",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        isFieldRequired: "true",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "status",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
      },
    ];
    return data;
  };
  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };
  /**not using For Now */
  // submit1 = item => {
  //   let x = categoriesFields
  //   let objcategories = {}

  //   objcategories["_id"] = item[0]["_id"]
  //   for (let x2 of x) {
  //     objcategories[x2] = item[0][x2]
  //   }
  //   let formFields = this.getFormFields()

  //   formFields = formFields.filter(y => x.includes(y.name))

  //   this.setState({
  //     openNewUserModal: true,
  //     item: objcategories,
  //     newFormFields: formFields
  //   });
  // }

  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    window.location.reload();
    /**not using For Now */
    // if (type == "submit") {
    // type == "submit"
    //   ?
    // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
    // }

    // : null;
  };
  /**not using For Now */
  const saveDataToServer = async (item, field, value) => {
    let body = item[0];
    body[field] = value;
    let userBody = Object.assign({}, body);
    // this.setState({
    //   isLoading: true
    // });
    if (body) {
      let method, apiUrl;
      method = "PUT";
      apiUrl = `${apiCalls["categories"]}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await this.setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
          // this.setState({
          //   isLoading: false
          // });
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };

  return (
    <span>
      {
        <DataTables
          {...props}
          getTableFields={getTableFields}
          formFields={getFormFields}
          //
          addRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          editRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          deleteRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          viewRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          /**not using For Now */
          // globalSearch={'Display Name/Email'}
          // type='Categories'
          // apiUrl={apiCalls.Categories}
          // exportRequried={true}
          printRequried={false}
          actionsTypes={false}
          /**not using For Now */
          //       [
          // {
          //   name: "Delete",
          // options: [
          // {
          //   label: "Delete",
          // value: "Delete",
          // show:
          // rolePermission && rolePermission == "Edit" ? true : false,
          // multiple: true,
          //           },
          // ],
          //       },

          // {
          //   'name': 'Block',
          //   "options": [
          //     {'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
          //   ]
          // },
          // {
          //   'name': 'ResetPassword',
          //   "options": [
          //     {'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
          //   ]
          // },
          // {
          //   'name': 'Submit',
          //   'action': this.submit,
          //   "options": [
          //     {'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
          //   ]
          // },
          // {
          //   name: "newModel",
          //   action: this.submit1,
          //   options: [
          //     {label: "newModel", value: "newModel", show: true, multiple: false }
          //   ]
          // }
          // ]}
          // addRequried={insertAdd}
          // editRequired={true}
          // deleteRequired={true}
          // viewRequired={true}
          settingsRequired={true}
          filterRequired={false}
          gridRequried={false}
          exportToCsv={false}
          refresh={true}
          getPagination={true}
          dateSearchRequired={false}
          selectionMode={true}
          searchInDateRangeField={""}
          setData={setData}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          sampleFilePath={filePath["categories"]}
          globalSearch={"Category Name / Type / Use Type"}
          type="Categories"
          routeTo={apiCalls["categories"]}
          displayViewOfForm="modal"
          sideFormLeftOrRight=""
          apiResponseKey={apiCalls["categories"].toLowerCase()}
          apiUrl={apiCalls["categories"]}
          selectedId={params.id}
          companyId={companyId}
        />
      }
      {isOpenFormModal ? (
        <FormModal
          /**not using For Now */
          // onRef={(ref) => (this.formModalRef = ref)}
          formType="edit"
          openFormModal={isOpenFormModal}
          formFields={formFields}
        />
      ) : null}
      {openNewUserModal ? (
        <NewUserModal
          openNewUserModal={openNewUserModal}
          cancelReset={cancelReset}
          item={item}
          newFormFields={newFormFields}
          recordId={item._id}
          entityType="categories"
          apiUrl={apiCalls["categories"]}
        />
      ) : null}
    </span>
  );
};

export default Categories;
